<div class="columns-loco">
    <span class="loco-tag">{{getLocomotiveId()}}</span>
</div>
<div class="columns-iu">
    <p-dropdown [panelStyleClass]="'dialog-dropdown'" class="pull-left usage-code" tabindex="{{tabLevel}}" appendTo='body' [options]="intendedUsageCodes" [(ngModel)]="selectedIntendedUsageCode" (onChange)='changeIntendedUsageCode()'></p-dropdown>
</div>
<div class="columns-reason">
    <p-dropdown [panelStyleClass]="'dialog-dropdown'" class="pull-left usage-reason" tabindex="{{tabLevel+1}}" appendTo='body' [options]="intendedUsageReason" [(ngModel)]="selectedIntendedUsageReasonCode" (onChange)='changeIntendedUsageReasonCode(true)'></p-dropdown>
</div>
<div class="columns-notes"> <span class="add-notes" *ngIf="!isNoteMandatory && !isNoteAvailable" tabindex="{{tabLevel+2}}" (click)="createNote()"><i class="fa fa-plus"></i> Notes</span>
</div>
<div *ngIf="isNoteMandatory || isNoteAvailable" class="intended-usage-notes">
    <div class='notes-block'>
        <input id="intdUsgNoteText{{indexPosition}}" class="{{(locoData && locoData.isIntendedUsageNotError)? 'p-inputfield train-placeholder p-inputfield-error' : 'train-placeholder p-inputfield'}}" tabindex="{{tabLevel+3}}" type='text' [(ngModel)]="locoData.intendedUsageNote"
            maxlength="30" />
        <div class="color-red error-text" *ngIf='locoData?.isIntendedUsageNotError'>Please enter valid text for notes.</div>
    </div>
    <span>max 30 char.</span>
    <div *ngIf="!showDeleteIcon">
        <i class="cross-icon" (click)="closeNote()" tabindex="{{tabLevel+4}}"></i></div>
</div>